export const SESSION_ID_CACHE_KEY = 'session-id';
export const SESSION_ID_MAX_DURATION = 1800000; // in miliseconds = 30 minutes
